import { render, staticRenderFns } from "./freeGifts.vue?vue&type=template&id=fdeef82a&scoped=true&"
import script from "./freeGifts.vue?vue&type=script&lang=js&"
export * from "./freeGifts.vue?vue&type=script&lang=js&"
import style0 from "./freeGifts.vue?vue&type=style&index=0&id=fdeef82a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeef82a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
